const SideBarMenu = [
  {
    name: "Dashboard",
    path: "/dashboard",
  },
  { name: "Upload", path: "/uploaded-videos" },
  {
    name: "Team Member",
    path: "/team-member",
  },
  {
    name: "Channels",
    path: "/Channels",
  },
  {
    name: "Transactions",
    path: "/transactions",
  },
  {
    name: "Calendar",
    path: "/calendar",
  },
  {
    name: "All Requests",
    path: "/all-requests",
  },
  {
    name: "All Projects",
    path: "/all-projects",
  },
  {
    name: "Chat",
    path: "/chat",
  },
  {
    name: "My Profile",
    path: "/my-profile",
  },
  {
    name: "Upload Video",
    path: "/upload-video",
  },
  {
    name: "Notifications",
    path: "/notification",
  },
];

const listingArr = [
  {
    name: "Lorem ipsum",
    price: "20000",
    sales: "20000",
    cashFlow: "20000",
    city: "New York",
    status: "Signed NDA",
  },
  {
    name: "Lorem ipsum",
    price: "20000",
    sales: "20000",
    cashFlow: "20000",
    city: "New York",
    status: "Signed NDA",
  },
  {
    name: "Lorem ipsum",
    price: "20000",
    sales: "20000",
    cashFlow: "20000",
    city: "New York",
    status: "Signed NDA",
  },
  {
    name: "Lorem ipsum",
    price: "20000",
    sales: "20000",
    cashFlow: "20000",
    city: "New York",
    status: "Signed NDA",
  },
  {
    name: "Lorem ipsum",
    price: "20000",
    sales: "20000",
    cashFlow: "20000",
    city: "New York",
    status: "Signed NDA",
  },
  {
    name: "Lorem ipsum",
    price: "20000",
    sales: "20000",
    cashFlow: "20000",
    city: "New York",
    status: "Signed NDA",
  },
  {
    name: "Lorem ipsum",
    price: "20000",
    sales: "20000",
    cashFlow: "20000",
    city: "New York",
    status: "Signed NDA",
  },
  {
    name: "Lorem ipsum",
    price: "20000",
    sales: "20000",
    cashFlow: "20000",
    city: "New York",
    status: "Signed NDA",
  },
  {
    name: "Lorem ipsum",
    price: "20000",
    sales: "20000",
    cashFlow: "20000",
    city: "New York",
    status: "Signed NDA",
  },
];

const ndaCard = [
  {
    title: "Total Listings",
    value: "123,456",
    percentageValue: "3.48",
  },
  {
    title: "Total Listings",
    value: "-123,456",
    percentageValue: "3.48",
  },
  {
    title: "Total Listings",
    value: "123,456",
    percentageValue: "3.48",
  },
];

const inquiedListingArr = [
  {
    name: "Lorem Ipsum",
    price: "2000",
    sales: "2000",
    cashFlow: "2000",
    city: "New York",
    status: "Signed NDA",
  },
  {
    name: "Lorem Ipsum",
    price: "2000",
    sales: "2000",
    cashFlow: "2000",
    city: "New York",
    status: "Signed NDA",
  },
  {
    name: "Lorem Ipsum",
    price: "2000",
    sales: "2000",
    cashFlow: "2000",
    city: "New York",
    status: "Signed NDA",
  },
  {
    name: "Lorem Ipsum",
    price: "2000",
    sales: "2000",
    cashFlow: "2000",
    city: "New York",
    status: "Signed NDA",
  },
  {
    name: "Lorem Ipsum",
    price: "2000",
    sales: "2000",
    cashFlow: "2000",
    city: "New York",
    status: "Signed NDA",
  },
  {
    name: "Lorem Ipsum",
    price: "2000",
    sales: "2000",
    cashFlow: "2000",
    city: "New York",
    status: "Signed NDA",
  },
  {
    name: "Lorem Ipsum",
    price: "2000",
    sales: "2000",
    cashFlow: "2000",
    city: "New York",
    status: "Signed NDA",
  },
  {
    name: "Lorem Ipsum",
    price: "2000",
    sales: "2000",
    cashFlow: "2000",
    city: "New York",
    status: "Signed NDA",
  },
  {
    name: "Lorem Ipsum",
    price: "2000",
    sales: "2000",
    cashFlow: "2000",
    city: "New York",
    status: "Signed NDA",
  },
];

export { SideBarMenu, listingArr, ndaCard, inquiedListingArr };
